import { useEffect, useMemo } from 'react'
import { useModel } from '@/app/store'
import { useGLTF, useAnimations, useIntersect } from '@react-three/drei'
import { BrightnessContrast, EffectComposer, HueSaturation } from '@react-three/postprocessing'
import * as THREE from 'three'


useGLTF.preload('/model/deer.glb')
const useDeerGLTF = () => useMemo(() => useGLTF('/model/deer.glb'), [])

export default function Model({children}: {children?: React.ReactNode}) {
    
    const model = useModel()
    const { scene, animations } = useDeerGLTF()
    const { actions } = useAnimations(animations, scene)

    const ref = useIntersect<THREE.Mesh>((visible) => {
        model.setVisible(visible)
    })

    useEffect(() => {
        model.setActions(actions)

        if (ref.current) {
            const box = new THREE.Box3().setFromObject(ref.current)
            const center = new THREE.Vector3()
            box.getCenter(center)
            ref.current.position.sub(center)
        }
    }, [])

    return (
        <>
        <mesh ref={ref}>
            <primitive object={scene} />
            {children}
        </mesh>
        <EffectComposer>
            <BrightnessContrast brightness={0.01} contrast={0.075} />
            <HueSaturation hue={0.0} saturation={0.2} />
        </EffectComposer>
        </>
    )
}

export function Lights() {
    return (
        <>
        {/* <ambientLight color="#FFFFFF" intensity={2.5} />
        <directionalLight color="#FFFFFF" intensity={1.5} position={[0, 1, 5]} />
        <pointLight color="#FFFFFF" intensity={2.5} position={[0, 2, 2]} /> */}
        <ambientLight color="#FFFFFF" intensity={3} />
        <directionalLight color="#FFFFFF" intensity={1.75} position={[0, 1, 5]} />
        <pointLight color="#FFFFFF" intensity={3} position={[0, 2, 2]} />
        </>
    )
}

Model.Lights = Lights